import React, { useMemo } from 'react'
import styled from 'styled-components'
import { strings } from '@constants'
import { Chip, TableColumns } from '@base'
import { Spacings, Text } from '@styles'
import { HeaderWapper, Heading, TableContainer, TableWapper, Wapper } from '../style'
import { paths } from '@routes'

const ChipWapper = styled(Chip)`
	border-radius: ${Spacings.SPACING_6};
	font-family: Poppins;
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.palette.text.white};
`

const RecentlyOnboarded = ({ organisation_onboarded }) => {
	const columns = useMemo(
		() => [
			{
				label: strings('buyer', 'name'),
				key: 'buyer_name',
				mobile: true,
			},
			TableColumns.dateColumn({ label: strings('onboarded', 'date'), align: 'center', key: 'onboarded_date', mobile: true }),
			{
				label: strings('kyc', 'status'),
				key: (itemData) => {
					return (
						<ChipWapper
							label={itemData?.kyc_status}
							status={'custom'}
							background={itemData?.kyc_status?.includes('DONE') ? '#558B2F' : '#D2A106'}
						/>
					)
				},
				mobile: false,
				align: 'right',
			},
		],
		[]
	)

	const rowClickHandler = (row) => {
		window.open(paths.admin_organisations_details_org(row?.org_id), '_blank')
	}
	return (
		<Wapper FlexColumn>
			<HeaderWapper>
				<Heading>Recently Onboarded</Heading>
			</HeaderWapper>
			<TableContainer>
				<TableWapper
					fullHeight={true}
					data={organisation_onboarded || []}
					columns={columns}
					rowsToDisplay={10}
					totalItemCount={50}
					page={0}
					rowClickable={true}
					onRowClick={rowClickHandler}
					hideFooter
				/>
			</TableContainer>
		</Wapper>
	)
}

export default RecentlyOnboarded
